import { render, staticRenderFns } from "./forum-detail.vue?vue&type=template&id=134a7ef4"
import script from "./forum-detail.vue?vue&type=script&lang=js"
export * from "./forum-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports